import BuyingGuides from './BuyingGuides.vue'

export default BuyingGuides
